import type { z } from 'zod';
import type { enquiryFormSessionSchema } from '../validation/enquiry-form-session-validation';

type EnquirySession = Partial<z.infer<typeof enquiryFormSessionSchema>> | null;

/**
 * Drop who is sending, keep what they wrote.
 *
 * "Not you? Switch account" corrects the identity on an enquiry the reader has
 * already composed. The session atom is the only store for the message — the
 * form writes it there on blur and unmounts when the gate takes the surface —
 * so clearing the whole session threw the enquiry away on the one path whose
 * stated purpose is to keep it.
 *
 * The contact fields go because they belong to the member signing out; the
 * message, attachments, chosen branch, Build Hub project and the item being
 * enquired about all belong to the enquiry and stay.
 */
export const forgetEnquiryIdentity = (
    session: EnquirySession,
): EnquirySession => {
    if (!session) return session;

    return {
        ...session,
        name: undefined,
        email: undefined,
        phoneNumber: undefined,
        postcode: undefined,
    };
};
